import { authApiInstance } from './client.js';

export const settingsApi = {
  updateProfile:  (payload) => authApiInstance.put('/auth/settings/profile', payload).then(r => r.data),
  changePassword: (payload) => authApiInstance.put('/auth/settings/password', payload).then(r => r.data),
};
